<div class="flex items-center gap-4">
  @if (file(); as f) {
    <div
      class="flex items-center gap-2 bg-th-light-blue w-full h-12 rounded-[3px] px-4 justify-between text-th-black"
    >
      <span
        class="text-[16px] font-medium text-th-black truncate min-w-0 flex-1"
        [title]="f.nombre"
        >{{ f.nombre }}</span
      >

      <div class="flex flex-row items-center gap-3 shrink-0">
        <div class="relative group">
          <mat-icon
            svgIcon="download-icon"
            class="text-black cursor-pointer w-5! h-5!"
            (click)="onDownload()"
          ></mat-icon>
          <div
            class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block pointer-events-none z-10"
          >
            <div
              class="bg-th-light-gray-2 text-th-black text-[14px] font-normal px-3 py-1.5 rounded-lg shadow-md whitespace-nowrap"
            >
              Descargar
            </div>
            <div
              class="w-0 h-0 mx-auto border-l-[6px] border-r-[6px] border-t-[7px] border-l-transparent border-r-transparent border-t-th-light-blue-2"
            ></div>
          </div>
        </div>

        <div class="relative group">
          <img
            src="icons/close_icon.svg"
            alt="Eliminar"
            class="w-5 h-5 cursor-pointer"
            (click)="onDelete()"
          />
          <div
            class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block pointer-events-none z-10"
          >
            <div
              class="bg-th-light-gray-2 text-th-black text-[14px] font-normal px-3 py-1.5 rounded-lg shadow-md whitespace-nowrap"
            >
              Eliminar
            </div>
            <div
              class="w-0 h-0 mx-auto border-l-[6px] border-r-[6px] border-t-[7px] border-l-transparent border-r-transparent border-t-th-light-blue-2"
            ></div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <button
      type="button"
      (click)="onUpload()"
      class="bg-th-light-blue text-th-dark-blue text-[16px] font-semibold cursor-pointer w-full h-12 rounded-[3px]"
    >
      <img src="icons/upload_icon.svg" alt="Subir" class="w-8 h-8 mr-1 inline-block" />
      Adjuntar documento
    </button>
  }
</div>
